import CoverService from '~/api/_services/CoverService';
import FeatureService from '~/api/_services/FeatureService';
import IdentityService from '~/api/_services/IdentityService';
import OrdersService from '~/api/_services/OrdersService';
import PrintService from '~/api/_services/PrintService';
import AsyncService from './_services/AsyncService';
import AuthorService from './_services/AuthorService';
import ComicBookService from './_services/ComicBookService';
import DocumentService from './_services/DocumentService';
import SeriesService from './_services/SeriesService';
import UniverseService from './_services/UniverseService';
import StrapiArticleService from './_services/StrapiArticleService';

export const API = {
    StrapiArticleService,
    IdentityService,
    AuthorService,
    UniverseService,
    ComicBookService,
    SeriesService,
    DocumentService,
    PrintService,
    CoverService,
    FeatureService,
    OrdersService,
    AsyncService,
};
